export const environment = {
  production: true,
  BaseURL: "https://cashmanagement.oags.gov.so/backend/api/"
};
